import { HStack, Stack } from '@chakra-ui/react';

import { AirlineInput } from '../Autocomplete/AirlineInput';
import { AirportTimezoneInput } from '../Autocomplete/AirportTimezoneInput';
import { SimpleField } from '../SimpleField';
import { SimpleInput } from '../SimpleInput';
import { AddressForm } from './AddressForm';

export const AirportForm = () => {
  return (
    <Stack direction="column" spacing={4} w="full">
      <Stack direction={{ base: 'column', md: 'row' }} w="full">
        <SimpleInput name="id" label="ID" placeholder="YVR" isRequired />
        <SimpleInput name="name" label="Name" placeholder="Vancouver International Airport" />
      </Stack>
      <HStack>
        <SimpleInput name="latitude" label="Latitude" type="number" isRequired />
        <SimpleInput name="longitude" label="Longitude" type="number" isRequired />
      </HStack>
      <SimpleField name="timeZone" label="Timezone" isRequired>
        <AirportTimezoneInput name="timeZone" />
      </SimpleField>
      <AddressForm name="address" />
      <AirlineInput name="providers" label="Airlines" placeholder="AC, UA, EK" isMulti />
    </Stack>
  );
};
